/* eslint-disable import/no-unresolved */
/* eslint-disable react/self-closing-comp */
/* eslint-disable arrow-body-style */
/* eslint-disable react/function-component-definition */
import UploadDocument from "src/shared/UploadDocument";
import { memo, useEffect, useState } from "react";
import CustomBoxModal from "src/shared/CustomModalBox";
import { Button } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import { uploadPAFFile } from "src/services/Dashboard";
import CustomBackDrop from "src/shared/CustomBackDrop";
import store from "src/redux/store";
import { SET_TOAST_ERROR } from "src/redux/Actions/common";
import { OPTIONS } from "src/helpers/Dashboard/resources";

interface Props {
  setActive: () => void;
}

function PAFUpload({ setActive }: Props) {
  const [pafFile, setPafFile] = useState<File | null>(null);
  const queryClient = useQueryClient();

  const downloadPAFFile = (url: any) => {
    const pdfUrl = url;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = ""; // specify the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const { mutate: mutatePAFFileUpload, isLoading: isPAFFileSubmitLoading } = useMutation(
    (file: File) => uploadPAFFile(file),
    {
      retry: false,
      onSuccess: async (res) => {
        setActive();
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            type: "success",
            message: "Successfully Uploaded PAF"
          })
        );
        await downloadPAFFile(res?.data?.processedSheetUrl);
        await queryClient.invalidateQueries({ queryKey: ["dashboard"] });
      },
      onError: () => {
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            duration: 4000,
            message: "Failed to upload PAF. Try again"
          })
        );
      }
    }
  );
  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  const handlePAFSubmit = () => {
    mutatePAFFileUpload(pafFile!);
  };
  return (
    <div>
      <CustomBackDrop open={isPAFFileSubmitLoading} />
      <CustomBoxModal onClose={setActive} className="">
        <div className="pb-4 md:px-4">
          <div>
            <UploadDocument
              className="w-64 md:w-96"
              title="Upload PAF"
              description={pafFile?.name ? pafFile?.name : "Click/Drag & Drop to upload"}
              supportedFileText="XLSX, CSV, XLS"
              setFile={setPafFile}
              acceptedFiles={OPTIONS?.pafFileExtensionSupported}
            />
          </div>
          <div className="text-center px-4 mt-2">
            <Button
              disabled={
                !(
                  pafFile &&
                  OPTIONS?.pafFileExtensionSupported?.includes(
                    `.${pafFile?.name?.split(".")?.pop()?.toLowerCase()}`
                  )
                )
              }
              variant="contained"
              onClick={handlePAFSubmit}
              className="!capitalize h-10 w-32 rounded-lg"
            >
              upload
            </Button>
          </div>
        </div>
      </CustomBoxModal>
    </div>
  );
}

export default memo(PAFUpload);
